import { ActionName } from "@faire/web/common/performance/userPerceivedLoadTiming/types";
import { configuration } from "@faire/web/common/settings/declarations/configuration";

/**
 * Configuration to control whether to log UPLT debug info in a PETE event for the specified pages.
 */
export const FE_ENABLE_UPLT_DEBUG_LOGGING = configuration({
  name: "FE_ENABLE_UPLT_DEBUG_LOGGING",
  identifier: "RetailerToken",
  client: "RETAILER",
  productArea: "FRONTEND_APIS",
  defaultValue: [] as ActionName[],
});
